
const provider = new firebase.auth.GoogleAuthProvider()
const auth = firebase.auth()

export default auth

export {
    provider,
}